import firebase from "firebase"
//import  { INVALIDATE_ACTIVITY } from '../activities/actions'

import {docsAsDataObject, docAsDataArray} from './utils/common'

/** GCI */
import formatAssessment from './actions-assessment'
//import formatReport from './utils/gci-trial/format-report'
import insertWordTable from './utils/gci-trial/office'

import formatReport from './utils/jfc-trial/format-report'

/*
//import formatAssessment from './actions-assessment-multi-indicator'
//import formatAssessment from './actions-assessment-object' // latest

import formatReport from './utils/assessment-by-employee'
//import formatReport from './utils/assessment-by-activity'
//import formatReport from './utils/assessment-by'
import insertWordTable from './utils/office'
*/

export const REQUEST_POSTS = 'assessments/REQUEST_POSTS'
export const RECEIVE_POSTS = 'assessments/RECEIVE_POSTS'
export const SELECT_SUBREDDIT = 'assessments/SELECT_SUBREDDIT'
export const INVALIDATE_SUBREDDIT = 'assessments/INVALIDATE_SUBREDDIT'



export function selectSubreddit(assessmentId) {
  
  return {
    type: SELECT_SUBREDDIT,
    assessmentId
  }
}

export function invalidateSubreddit(assessmentId) {
  return {
    type: INVALIDATE_SUBREDDIT,
    assessmentId
  }
}

function requestPosts(assessmentId) {
  return {
    type: REQUEST_POSTS,
    assessmentId
  }
}

function receivePosts(assessmentId, json) {

  return {
    type: RECEIVE_POSTS,
    assessmentId,
    //posts: json.data.children.map(child => child.data),
    posts: json,
    receivedAt: Date.now()
  }
}

function fetchPosts(id, store) {
  return (dispatch) => {
    dispatch(requestPosts(id))

    return store.firestore.get('assessments/' + id)
      .then( snapshot => snapshot.ref.collection('activities').get()
              .then(activitiesRef => {
                let activities = []
                activitiesRef.forEach( doc => activities.push(doc.data()))
                dispatch(receivePosts(id, activities)) 
              }) 
        )

  }
}



function shouldFetchPosts(state, id) {
  const posts = state.activitiesByAssessmentId[id]
  if (!posts) {
    return true
  } else if (posts.isFetching) {
    return false
  } else {
    return posts.didInvalidate
  }
}


export function fetchPostsIfNeeded(id, store) {
  
  return (dispatch, getState) => {    
    if (shouldFetchPosts(getState(), id)) {

      return dispatch(fetchPosts(id,store))
    }
  }
}

export const LOAD_ASSESSMENTS = 'LOAD_ASSESSMENTS'
export const RECEIVED_ASSESSMENTS = 'RECEIVED_ASSESSMENTS'
export const SELECT_ASSESSMENT = 'assessments/SELECT_ASSESSMENT'
export const INVALIDATE_ASSESSMENT = 'assessments/INVALIDATE_ASSESSMENT'
export const SUMMARIZE_CPS = 'assessments/SUMMARIZE_CPS'
export const LOAD_CPS = 'assessments/LOAD_CPS'

function loadActivities(assessment) {
  return {
    type: SELECT_ASSESSMENT,
    assessment
  }
}
/*
export function selectAssessment(assessment){
  return (dispatch) => {
    const promises = assessment.activityRefs.map(activity => activity.get())
    Promise.all(promises).then(activities => dispatch(loadActivities(assessment,activities)))
  }
}
*/

export function selectAssessment(assessment){
  return (dispatch) => {


      const promises = assessment.activityRefs.map(activity =>
          activity.get().then(doc => ({ id: doc.id, data:doc.data()}) )  )
      
      Promise.all(promises)
        .then(activities => {
          const act = { id: assessment.id, answers:assessment.answers, employeeId: assessment.employeeId,
            employeeRef: assessment.employeeRef,
            employee: assessment.employee,
            activities }

          dispatch(loadActivities(act))
          formatAssessment(act).then(cps => dispatch(summarizeCps(cps)))
          
        })
  }

}





export function summarizeCps(cps) {
  return {
    type: SUMMARIZE_CPS,
    cps
  }
}

export function invalidateAssessment() {
  
  return {
    type: INVALIDATE_ASSESSMENT
  }
}

export function receivedAssessments(assessments) {
    return {
        type: RECEIVED_ASSESSMENTS,
        assessments
    }
}

/*
//    .filter(assessment => assessment.rater.id == user.uid)

function populateEmployeeDataByUser(user,store) {
  return store.firestore.get( { collection: 'assessmentsByRater', where: ['rater.id','==', user.uid] }).then(snapshot => {
    const promises = []
    snapshot.docs.map( doc => doc.data() )
    .map(assessment => promises.push(assessment.employee.get()) )
    return Promise.all(promises)
  })
}
*/


function populateEmployeeDataByUser(user,store) {
    return store.firestore
      .get('assessmentsByRater')
      //.get({ collection: 'assessmentsByRater',where: ['rater.id','==', user.uid] })
      .then(snapshot => {
      
      const eePromises = []
      snapshot.docs.map( docAsDataArray  )

      .filter(assessment => assessment.data.rater && assessment.data.rater.id === user.uid)
      //.filter(assessment => assessment.data.company.id == 'GCI')
      //.filter(assessment => assessment.data.company.id == 'JFC')
      .map(assessment => eePromises.push(assessment.data.employee.get()
          .then(employee => (  { id: assessment.id, 
              activityRefs: assessment.data.activities, 
              answerRefs: assessment.data.answers,
              answers: assessment.data.answers,
              employeeId: employee.id,
              employee: employee.data(),
              employeeRef: employee.ref
          } ) )  ) )
      return Promise.all(eePromises)

      }
    )    
}



export function loadAssessmentsData(user,store){
  return (dispatch) => {

      dispatch({type: LOAD_ASSESSMENTS})
      populateEmployeeDataByUser(user,store)
      .then(assessments => { dispatch(receivedAssessments(assessments)) })
  }

}


function fetchAnswers(data) {
  Object.entries(data.activities).reduce( (acc,[activityId,activity]) => {
    //activity.competencies.map(ref => ref.id )
    return acc
  }, {}) 

  const promises = Object.entries(data.cps).map( ([id,cp]) =>
        
        firebase.firestore().collection('assessmentsByRater').doc(id)
        .collection('answers').doc('D9kJxqEERNKEo2XWthJ5')
        .collection('competencies').get()  
    )

  return Promise.all(promises)
}


function fetchAnswersByActivity(data) {



  
  let promiseIndex = 0
  const promises = []

  const cps = Object.entries(data.assessments).reduce( (acc,[id,assessment]) => {

    assessment.activities.map(activity => { 
      const dataAct = data.activities[activity.id] 
      return dataAct.competencies.map(cp => {
          const dataCp = data.cps[cp.id]

          const promise = firebase.firestore()
            .collection('assessmentsByRater').doc(id)
            .collection('answers').doc(activity.id)
            .collection('competencies').doc(cp.id).collection('dimensions').get()
          promises.push(promise)


          acc[cp.id] 
            ? acc[cp.id].activities[activity.id] = {name: dataAct.name, promiseIndex}
            : acc[cp.id] = {
                name: dataCp.name,
                activities: {
                  [activity.id]: {name: dataAct.name, promiseIndex}
                } }
          promiseIndex++
        })
        
      })
    return acc
  },{})

  
/*

  const promises = Object.entries(data.assessments).reduce( (acc,[id,assessment]) => {

    assessment.activities.map(activity => { 
      const dataAct = data.activities[activity.id] 
      return dataAct.competencies.map(cp => {
        const dataCp = data.cps[cp.id]
          acc.push(firebase.firestore().collection('assessmentsByRater').doc(id)
          .collection('answers').doc(activity.id)
          .collection('competencies').doc(cp.id)
          .collection('dimensions').get() ) 
      })
    })

      return acc
    },[])

*/

  return Promise.all(promises).then(values =>  {
    data.answers = values.map(docsAsDataObject)  
    data.c = cps
    return data
  })
}


// FIXME employeeId is not a valid where clause since employee is a reference field
//store.firestore.get({collection: 'assessmentsByRater', where: ['employee.id','==',employeeId] })
export function generateAssessmentsByEmployee(employee,employeeData,store,showCounts) {
  const companyId = employeeData.company.id
  const firestore = firebase.firestore()
  const assessmentsByRater = firestore.collection('assessmentsByRater').where('employee','==',employee)
  const cps = firestore.collection('competencies').where('company.id','==',companyId)
  const activities = firestore.collection('activities').where('company.id','==',companyId)

  return (dispatch) => {

    Promise.all([ assessmentsByRater.get(), cps.get(), activities.get()])
      .then(formatReport)
      .then(fetchAnswersByActivity)
      .then(data => {console.log(data); return data; })
      .then(report => insertWordTable(report,showCounts,dispatch))
      .catch(err => dispatch({type: 'ASYNC_FAILED',message: err.message}))

  }
}


export function generateAssessmentsByEmployeeId(employeeId,store,showCounts) {
  return (dispatch) => {
    console.log(employeeId)

    const employee = firebase.firestore().collection('employees').doc(employeeId)
    const asnap = firebase.firestore().collection('assessmentsByRater')
      .where('employee','==',employee)
    asnap.get()
      //.then(snapshot => snapshot.docs.reduce( (acc, doc) => ({[doc.id]:doc.data() }),{}  ) )
      .then(snapshot => snapshot.docs.reduce( (acc, doc) => {acc[doc.id] = doc.data(); return acc},{}  ) )
      .then(data => console.log(data))
    asnap.get()
      .then(snapshot => snapshot.docs.map(doc => console.log(doc.ref.collection('answers')) ) )
  }
}


export const LOAD_ACTIVITIES = 'activities/LOAD_ACTIVITIES'

export function handleOnChange(text,columnName,rowIndex) {
    return (dispatch, getState) => {
        const data = getState().upload.content.data.slice(0)
        data[rowIndex][columnName] = text
        dispatch({type: 'ON_CHANGE', data, text, columnName,rowIndex })
    }
}

/*
export function loadActivities() {
  return (dispatch, getState) => {
    const activities = []
    
    dispatch({ type: LOAD_ACTIVITIES, activities })
  }
}
*/

export const INIT_BREADCRUMB = 'assessments/INIT_BREADCRUMB'
export const ADD_BREADCRUMB = 'assessments/ADD_BREADCRUMB'

export function initBreadcrumb(breadcrumbs) {
  return {
    type: INIT_BREADCRUMB,
    breadcrumbs
  }
}

export function addBreadcrumb(breadcrumb) {
  return {
    type: ADD_BREADCRUMB,
    breadcrumb
  }
}


export const FORMAT_EMPLOYEE = 'assessment/FORMAT_EMPLOYEE'


export function formatEmployee(employee) {
  return {
    type: FORMAT_EMPLOYEE,
    employee
  }
}




// WEBPACK FOOTER //
// ./src/assessments/actions.js